<ion-split-pane [when]="showContent" contentId="main-content">
  <ion-menu contentId="main-content">
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title style="font-size: 1rem">
          {{ currentUser ? currentUser.user.role.name : "" }}</ion-title
        >
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="side-menu-container">
        <div class="">
          <button
            *ngIf="!isProduction"
            pButton
            pRipple
            label="EMPLOYEES"
            icon="pi pi-id-card"
            class="p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub"
            (click)="employees()"
          ></button>
          <button
            *ngIf="currentUser && currentUser.user.role.name === 'SUPERUSER'"
            pButton
            pRipple
            label="Time & Attendance"
            icon="pi pi-list"
            [class]="
              (currentUser &&
                currentUser.user.role.name === 'SUPERUSER' &&
                activeMenuItem === 'dashboard' &&
                !showDashboardSubmenu) ||
              activeMenuItem === 'dashboard' ||
              (!showDashboardSubmenu &&
                (activeMenuItem === 'auditorDashboard' ||
                  activeMenuItem === 'coordinatorDashboard'))
                ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
            "
            (click)="showDashboard()"
          ></button>

          <ion-menu-toggle
            autoHide="false"
            *ngIf="
              currentUser &&
              (currentUser.user.role.name === 'COORDINATOR' ||
                currentUser.user.role.name === 'AUDITOR')
            "
          >
            <button
              pButton
              pRipple
              label="Time & Attendance"
              icon="pi pi-align-left"
              [class]="
                activeMenuItem === 'dashboard'
                  ? 'p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                  : 'p-button-outlined p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
              "
              style="padding-right: 0.5rem; width: 100%"
              (click)="showDashboard()"
            ></button>
          </ion-menu-toggle>

          <ion-menu-toggle
            autoHide="false"
            *ngIf="currentUser && currentUser.user.role.name === 'COORDINATOR'"
          >
            <button
              pButton
              pRipple
              label="INCOMING SHIFTS"
              icon="pi pi-align-left"
              [class]="
                activeMenuItem === 'incomingShifts'
                  ? 'p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                  : 'p-button-outlined p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
              "
              style="padding-right: 0.5rem; width: 100%"
              (click)="incomingShifts()"
            ></button>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <div
              class="mr-2"
              *ngIf="
                currentUser &&
                currentUser.user.role.name === 'SUPERUSER' &&
                showDashboardSubmenu
              "
            >
              <button
                pButton
                pRipple
                label="COORDINATOR"
                icon="pi pi-align-left"
                [class]="
                  activeMenuItem === 'coordinatorDashboard'
                    ? 'p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="
                  font-size: 0.7rem;

                  padding-right: 0.5rem;
                  width: 100%;
                "
                (click)="coordinatorDashboard()"
              ></button>

              <button
                pButton
                pRipple
                label="AUDITOR"
                icon="pi pi-align-left"
                [class]="
                  activeMenuItem === 'auditorDashboard'
                    ? 'p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="
                  font-size: 0.7rem;

                  padding-right: 0.5rem;
                  width: 100%;
                "
                (click)="auditorDashboard()"
              ></button>

              <button
                pButton
                pRipple
                label="INCOMING SHIFTS"
                icon="pi pi-align-left"
                [class]="
                  activeMenuItem === 'incomingShifts'
                    ? 'p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="font-size: 0.7rem; padding-right: 0.5rem; width: 100%"
                (click)="incomingShifts()"
              ></button>
              <button
                pButton
                pRipple
                label="ABSENCES"
                icon="pi pi-align-left"
                [class]="
                  activeMenuItem === 'absences'
                    ? 'p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm mb-2 ml-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="font-size: 0.7rem; padding-right: 0.5rem; width: 100%"
                (click)="absences()"
              ></button>
            </div>
            <div
              *ngIf="
                currentUser &&
                (currentUser.user.role.name === 'COORDINATOR' ||
                  currentUser.user.role.name === 'AUDITOR')
              "
            >
              <button
                pButton
                pRipple
                label="ABSENCES"
                icon="pi pi-align-left"
                [class]="
                  activeMenuItem === 'absences'
                    ? 'p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                    : 'p-button-outlined p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                "
                style="padding-right: 0.5rem; width: 100%"
                (click)="absences()"
              ></button>
            </div>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <button
              pButton
              pRipple
              label="MDM"
              icon="pi pi-eye"
              [class]="
                activeMenuItem === 'punchBuddyDashboard'
                  ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                  : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
              "
              (click)="punchBuddyDashboard()"
            ></button>
          </ion-menu-toggle>

          <button
            pButton
            pRipple
            label="ANALYTICS"
            icon="pi pi-chart-bar"
            [class]="
              (currentUser &&
                currentUser.user.role.name === 'SUPERUSER' &&
                activeMenuItem === 'analytics' &&
                !showAnalyticsSubmenu) ||
              activeMenuItem === 'analytics' ||
              (!showAnalyticsSubmenu && activeMenuItem === 'analytics')
                ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
                : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-main'
            "
            (click)="analytics()"
          ></button>

          <ion-menu-toggle autoHide="false">
            <div
              class="mr-2 mb-2"
              *ngIf="
                currentUser &&
                (currentUser.user.role.name === 'SUPERUSER' ||
                  currentUser.user.role.name === 'COORDINATOR') &&
                showAnalyticsSubmenu
              "
            >
              <button
                *ngIf="
                  currentUser &&
                  (currentUser.user.role.name === 'SUPERUSER' ||
                    currentUser.user.role.name === 'COORDINATOR')
                "
                pButton
                pRipple
                label="REPORTS"
                icon="pi pi-chart-bar"
                [class]="
                  (activeMenuItem === 'reports' && !showReportSubmenu) ||
                  activeMenuItem === 'reports' ||
                  (!showReportSubmenu &&
                    (activeMenuItem === 'reportByCategory' ||
                      activeMenuItem === 'reportByLocation' ||
                      activeMenuItem === 'reportByEmployee' ||
                      activeMenuItem === 'reportAllTimeEntries' ||
                      activeMenuItem === 'reportForCoordinator' ||
                      activeMenuItem === 'reportSBTC' ||
                      activeMenuItem === 'reportCarraway' ||
                      activeMenuItem === 'reportAnomaly' ||
                      activeMenuItem === 'payrollReport'))
                    ? 'w-full p-button-sm ml-2 mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full ml-2 mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="padding-right: 0.5rem; width: 100%"
                (click)="reports($event)"
              ></button>

              <ion-menu-toggle autoHide="false">
                <div
                  class="mr-2 mb-2"
                  *ngIf="
                    currentUser &&
                    (currentUser.user.role.name === 'SUPERUSER' ||
                      currentUser.user.role.name === 'COORDINATOR') &&
                    showReportSubmenu
                  "
                >
                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="BY CATEGORY"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportByCategory'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportByCategory()"
                  ></button>
                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="BY LOCATION"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportByLocation'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportByLocation()"
                  ></button>

                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="BY EMPLOYEE"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportByEmployee'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportByEmployee()"
                  ></button>

                  <button
                    pButton
                    pRipple
                    label="ALL TIME ENTRIES"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportAllTimeEntries'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportAllTimeEntries()"
                  ></button>

                  <button
                    pButton
                    pRipple
                    label="COORDINATOR REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportForCoordinator'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportForCoordinator()"
                  ></button>

                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="SBTC REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportSBTC'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportSBTC()"
                  ></button>

                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="CARRAWAY REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportCarraway'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportCarraway()"
                  ></button>

                  <!-- <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="ANOMALY REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'reportAnomaly'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="reportAnomaly()"
                  ></button> -->

                  <button
                    *ngIf="
                      currentUser && currentUser.user.role.name === 'SUPERUSER'
                    "
                    pButton
                    pRipple
                    label="PAYROLL REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'payrollReport'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="payrollReport()"
                  ></button>
                </div>
              </ion-menu-toggle>

              <button
                pButton
                pRipple
                label="POWERBI"
                icon="pi pi-chart-bar"
                [class]="
                  (activeMenuItem === 'powerbi' && !showPowerBISubmenu) ||
                  activeMenuItem === 'powerbi' ||
                  (!showPowerBISubmenu &&
                    (activeMenuItem === 'summaryDashboard' ||
                      activeMenuItem === 'shiftView' ||
                      activeMenuItem === 'iyaEngagementReport' ||
                      activeMenuItem === 'chargeReport'))
                    ? 'w-full p-button-sm ml-2 mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full ml-2 mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                style="padding-right: 0.5rem; width: 100%"
                (click)="powerbi($event)"
              ></button>

              <ion-menu-toggle autoHide="false">
                <div class="mr-2 mb-2" *ngIf="showPowerBISubmenu">
                  <button
                    pButton
                    pRipple
                    label="SUMMARY DASHBOARD"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'summaryDashboard'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="summaryDashboard()"
                  ></button>
                  <button
                    pButton
                    pRipple
                    label="SHIFT VIEW"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'shiftView'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="shiftView()"
                  ></button>

                  <button
                    pButton
                    pRipple
                    label="IYA ENGAGEMENT REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'iyaEngagementReport'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="iyaEngagementReport()"
                  ></button>

                  <button
                    pButton
                    pRipple
                    label="CHARGE REPORT"
                    icon="pi pi-chart-bar"
                    [class]="
                      activeMenuItem === 'chargeReport'
                        ? 'p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                        : 'p-button-outlined p-button-sm mb-2 ml-3 menu-button text-left pl-2 pr-3 menu-button-sub2'
                    "
                    style="
                      font-size: 0.7rem;
                      padding-right: 0.5rem;
                      width: 100%;
                    "
                    (click)="chargeReport()"
                  ></button>
                </div>
              </ion-menu-toggle>
            </div>
          </ion-menu-toggle>
        </div>

        <div class="">
          <ion-menu-toggle autoHide="false">
            <div class="mr-2 mb-2" *ngIf="showSettingsSubmenu">
              <button
                pButton
                pRipple
                label="LOCATIONS"
                icon="pi pi-map-marker"
                [class]="
                  activeMenuItem === 'clockingRadius'
                    ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                (click)="clockingRadius()"
              ></button>

              <button
                *ngIf="
                  currentUser && currentUser.user.role.name === 'SUPERUSER'
                "
                pButton
                pRipple
                label="USERS MGT"
                icon="pi pi-users"
                [class]="
                  activeMenuItem === 'userManager'
                    ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                (click)="userManager()"
              ></button>

              <button
                *ngIf="
                  currentUser && currentUser.user.role.name === 'SUPERUSER'
                "
                pButton
                pRipple
                label="ROLES MGT"
                icon="pi pi-user"
                [class]="
                  activeMenuItem === 'roleManager'
                    ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                (click)="roleManager()"
              ></button>

              <button
                *ngIf="
                  currentUser && currentUser.user.role.name === 'SUPERUSER'
                "
                pButton
                pRipple
                label="CLIENT TIME"
                icon="pi pi-clock"
                [class]="
                  activeMenuItem === 'clientTime'
                    ? 'w-full p-button-sm mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                    : 'p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub'
                "
                (click)="clientTime()"
              ></button>

              <button
                pButton
                pRipple
                label="LOGOUT"
                icon="pi pi-sign-out"
                class="p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-sub"
                (click)="logout()"
              ></button>
            </div>
          </ion-menu-toggle>

          <button
            pButton
            pRipple
            label="SETTINGS"
            icon="pi pi-cog"
            class="p-button-outlined p-button-sm w-full mb-2 menu-button text-left pl-2 pr-3 menu-button-main"
            (click)="settings()"
          ></button>
        </div>
      </div>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"> </ion-router-outlet>
</ion-split-pane>

<!-- Loading spinner -->
<div *ngIf="loading$ | async" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
